import { ResponsiveStyleValue, ThemeUICSSObject } from 'theme-ui';
import defaultPalette from './base/colors/defaultPalette';

/**
 * Esta función devuelve un array de valores para los distintos breakpoints.
 *
 * **Importante** Debido a un issue con ThemeUI, es necesario agregar un
 * breakpoint inicial de 0px para las vistas de impresión. El comportamiento por
 * defecto será, si se pasa un valor para el índice 4, esta será tomada como
 * vista de impresión, sino se tomará el valor de mayor índice menor que 4.
 *
 * @example
 *
 * display: responsive({0: 'none', 3: 'block'}) // display: ['block', 'none', null, null, 'block'];
 */

export function responsive<T>(values: {
  print?: T;
  [key: number]: undefined | T;
}): ResponsiveStyleValue<T> {
  const returnArray = [];
  const max = 6;
  for (let i = 0; i <= max; i++) returnArray[i + 1] = values[i] ?? null;

  if (values.print) returnArray[0] = values.print;
  else {
    for (let i = 5; i >= 0; i--) {
      if (values[i] !== undefined) returnArray[0] = values[i];
    }
  }

  return returnArray;
}

/**
 * Este método permite aplicar espacios (gaps, márgenes y paddings) que se
 * tendrán un comportamiento responsivo por defecto. Esto es, cuando tenemos un
 * padding en una vista de escritorio, probablemente sea demasiado grande al
 * llevarlo a celular. Con esta función se elimina el problema de calcular para
 * cada elemento en forma individual y el problema se convierte en encontrar
 * una única fórmula que quede correcta para todos los breakpoints.
 *
 * @example
 *
 * '.wellPaddedElement': {
 *    p: spacing(6),
 *    pt: spacing(8)
 * }
 */
export function spacing(index: number): ResponsiveStyleValue<number> {
  return defaultPalette.spacing(index) ?? index;
}

export const smallButton = {
  py: 2,
  px: 4,
  fontSize: '0.9em',
};

export const focusOutline: ThemeUICSSObject = {
  outlineColor: 'outlineColor',
  outlineWidth: '3px',
  outlineStyle: 'solid',
  outlineOffset: '-3px',
};
